import React from "react";

const NotFoundPage = () => {
  return (
    <>
      <main className="!grid !min-h-screen !place-items-center !bg-[#008080] !px-6 !py-24 sm:!py-32 lg:!px-8">
        <div className="!text-center">
          <p className="!text-base !font-semibold !text-[#ff850f]">404</p>
          <h1 className="!mt-4 !text-5xl !font-semibold !tracking-tight !text-balance !text-white sm:!text-7xl">Page not found</h1>
          <p className="!mt-6 !text-lg !font-medium !text-pretty !text-gray-400 sm:!text-xl/8">Sorry, we couldn’t find the page you’re looking for.</p>
          <div className="!mt-10 !flex !items-center !justify-center !gap-x-6">
            <a href="/" className="!rounded-md !bg-[#ff850f] !px-3.5 !py-2.5 !text-sm !font-semibold !text-white !shadow-xs hover:!bg-[#ff850f] focus-visible:!outline-2 focus-visible:!outline-offset-2 focus-visible:!outline-none">
              Go back home
            </a>
          </div>
        </div>
      </main>
    </>
  );
};

export default NotFoundPage;
